import React, { useState } from 'react';
import { Grid, Button, Container, CssBaseline, FormControl, InputLabel, MenuItem, Select, Typography, Card, CardContent, CardMedia } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';



const BizzNews = () => {
    const [ticker, setTicker] = useState('');
    const [topic, setTopic] = useState('');
    const [newsFeed, setNewsFeed] = useState([]);
    const theme = useTheme();

    const tickerOptions = [
        "AAPL", "MSFT", "AMZN", "GOOG", "GOOGL", "FB", "BRK.A", "BRK.B", "JNJ", "JPM",
        "V", "PG", "MA", "INTC", "UNH", "VZ", "HD", "T", "KO", "MRK",
        "PEP", "PFE", "CVX", "CMCSA", "XOM", "BA", "WMT", "BAC", "CSCO", "ORCL",
        "DIS", "IBM", "MMM", "GS", "MCD", "NKE", "AXP", "WBA", "DD", "LLY",
        "TRV", "UTX", "CAT", "HON", "UNP", "MO", "SLB", "AGN", "OXY", "AMGN",
        "USB", "MDT", "GILD", "PYPL", "PM", "SBUX", "TMO", "TXN", "ABBV", "ANTM",
        "F", "GM", "C", "MS", "WFC", "BMY", "CELG", "CI", "CL", "CVS",
        "DHR", "DUK", "EMR", "EXC", "FIS", "GD", "GE", "HAL", "KMB", "LOW",
        "MET", "PNC", "SPG", "TJX", "TGT", "UPS", "WMB", "XEL", "ZTS", "ABT",
        "ACN", "ADBE", "AIG", "ALL", "AMT", "AON", "APD", "ADP", "AVGO", "BDX"
    ];
    const topicOptions = ['blockchain', 'earnings', 'ipo', 'mergers_and_acquisitions', 'technology'];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setNewsFeed([]);
        const response = await fetch(`${process.env.REACT_APP_BACK_END_URL}/stocks/news_feed/sentiment/senti`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ ticker, topic })
        });

        const data = await response.json();
        setNewsFeed(data);
    };

    return (
        <div style={{ background: theme.palette.background.default, height: '100vh' }}>
            <Navbar />
            <Grid container direction="row" style={{ height: '100%' }}>
                <Grid item xs={2} sm={2}>
                    <Sidebar />
                </Grid>
                <Grid item xs={10} sm={10} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <Container style={{ maxHeight: 'calc(100vh - 100px)', overflow: 'auto',msOverflowStyle: '-ms-autohiding-scrollbar' }}>
                        <CssBaseline />
                        <FormControl variant="filled" style={{ minWidth: 200, marginTop: "20px" }} >
                            <InputLabel id="ticker-select-label" style={{ color: '#000000' }}>Ticker</InputLabel>
                            <Select labelId="ticker-select-label" style={{ color: '#000000' }} value={ticker} onChange={e => setTicker(e.target.value)}>
                                {tickerOptions.map(ticker => <MenuItem key={ticker} value={ticker} style={{ color: '#000000' }}>{ticker}</MenuItem>)}
                            </Select>
                        </FormControl>

                        <FormControl variant="filled" style={{ minWidth: 200, marginTop: "20px" }}>
                            <InputLabel id="topic-select-label" style={{ color: '#000000' }}>Topic</InputLabel>
                            <Select labelId="topic-select-label" value={topic} style={{ color: '#000000' }} onChange={e => setTopic(e.target.value)}>
                                {topicOptions.map(topic => <MenuItem key={topic} value={topic} style={{ color: '#000000' }}>{topic}</MenuItem>)}
                            </Select>
                        </FormControl>

                        <Button variant="contained" color="primary" onClick={handleSubmit} style={{ marginTop: "20px" }} >Submit</Button>

                        {newsFeed.map((article, index) => (
                            <a href={article.url} target="_blank" style={{ textDecoration: 'none' }}>
                                <Card key={index} sx={{ width: '60%', margin: 'auto', marginTop: 2, marginBottom: 2 }}>
                                    <CardMedia component="img" image={article.banner_image} alt={article.title} style={{ width: '100%', height: '300px' }} />
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: '#000000' }}>{article.title}</Typography>
                                        <Typography style={{ color: '#000000' }}>{article.summary}</Typography>
                                        <Typography style={{ color: '#000000' }}>By: {article.authors.join(', ')}</Typography>
                                    </CardContent>
                                </Card>
                            </a>
                        ))}
                    </Container>

                </Grid>
            </Grid>
        </div>
    );
}

export default BizzNews;
